
import api from "~api";

import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
XHeader,
Group,
Cell,
XInput,
XButton,
Selector,
Tabbar,TabbarItem,Drawer,ViewBox
},
data () {
return {
city:"",
classmates:[


























],
}
},
mounted () {

},
created(){
this.getData()
},
methods: {
goNext () {
this.$router.go(-1);
},
getData(){
var params = this.$route.params.params;
this.city = this.$route.params.city;
api.post("/api/TravelInformation/peerRecommendations",params).then( res=>{
if(res.data!=null){
this.classmates = res.data.results;
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/friendRecommended.vue